<vnm-persistent-notification
  icon="exclamation-triangle"
  [message]="'contact-notification.message' | translate: { value: record.value | contact }"
  [record]="record"
  (click)="presentConfirmation()"
></vnm-persistent-notification>
